<footer aria-label="Barra de direitos autorais" class="w-full !bg-verde-saude-base text-white">
    <div
        class="mx-auto max-w-[1440px] w-full min-h-12 sm:min-h-14 grid grid-cols-1 sm:grid-cols-3 items-center gap-2 sm:gap-0 px-3 sm:px-6 lg:px-10 2xl:px-20 py-2">
        <div class="justify-self-center sm:justify-self-start text-center sm:text-left">
            <span class="text-[12px] sm:text-[13px] leading-tight break-words">© Copyright {{ currentYear }} Libbs
                Farmacêutica • Todos os Direitos Reservados.</span>
        </div>
        <div class="justify-self-center text-center">
            <span class="text-[12px] sm:text-[13px] leading-tight break-words">Desenvolvido por MaxProcess</span>
        </div>
        <div class="justify-self-center sm:justify-self-end text-center sm:text-right font-bold">
            <span class="text-[14px] sm:text-[16px] leading-tight">Libbs</span>
        </div>
    </div>
</footer>